import styled from 'styled-components';

const StyledVendorStatusSelector = styled.div`
  align-items: center;
  display: flex;
`;

export {
  StyledVendorStatusSelector,
};
